import { hostInputDominanceState, hostMatchmakingState } from '../../stores/shared';
import { setWindowState } from '../ipcInterface';
import { stopStream } from '../peers/host';
import { shouldSuppressHostDominanceKick } from './adminConnectGuard';

// "Host Hard Kicked" analytics now fires from PlaycastService (C++) directly
// to the realtime-api /realtime/events/track endpoint. PlaycastService survives
// the guest session teardown, making it the only reliable emitter. The old
// host-frontend analytics call was removed because this process gets killed
// before it can send.

// Delay between kicking players and closing the Electron window. Gives the
// WebRTC data channel time to flush the __peerClose message to players.
const KICK_FLUSH_DELAY = 200;

export const initializeHostInputDominanceEvents = () => {
  let kicked = false;

  hostInputDominanceState.addListener((state) => {
    // Only keyboard dominance triggers hard kick (spacebar press in nonsole).
    // Mouse dominance scoring is disabled in C++ (ApplyActivity is dead code),
    // so state.mouse never becomes true in practice.
    if (!state.keyboard) return;
    if (!hostMatchmakingState.currentState.guestAccount) return;
    // Admin Connect: operator keyboard is expected; kicking aborts the handshake
    // or tears down Nonsole under an elevated shell.
    if (shouldSuppressHostDominanceKick()) {
      console.log('[Host Input Dominance] Keyboard dominance ignored during admin connect/session');
      return;
    }
    if (kicked) return;
    kicked = true;

    // Kick players immediately so the __peerClose message is sent before C++
    // teardown (PerformNonsoleTeardown) kills this Electron process.
    console.warn('[Host Input Dominance] Keyboard dominance — kicking players immediately');
    stopStream('host:host_app_closed');

    setTimeout(() => setWindowState('closed'), KICK_FLUSH_DELAY);
  });
};
